import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  ProjectsCalcViewComponent
} from 'projects/app-misc/src/app/modules/project-calc/projects-calc-view/projects-calc-view.component';
import {
  ProjectCalcDetailViewComponent
} from 'projects/app-misc/src/app/modules/project-calc/projects-calc-view/project-calc-detail-view/project-calc-detail-view.component';
import {
  ProjectAreaViewComponent
} from 'projects/app-misc/src/app/modules/project-calc/projects-calc-view/project-calc-detail-view/project-area-view/project-area-view.component';

const projectCalcRoutes: Routes = [
  {
    path: '',
    component: ProjectsCalcViewComponent,
    children: [
      {
        path: ':id',
        component: ProjectCalcDetailViewComponent,
        children: [
          {
            path: 'area/:id',
            component: ProjectAreaViewComponent
          }
        ]
      }
    ]
  }
]

@NgModule({
  imports: [
    RouterModule.forChild(projectCalcRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class ProjectCalcRoutingModule {
}
